import { render, staticRenderFns } from "./PayBackTab.vue?vue&type=template&id=2b5c4b24&"
import script from "./PayBackTab.vue?vue&type=script&lang=js&"
export * from "./PayBackTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports